import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { View, TextStyle, ViewStyle } from 'react-native'
import { useStores } from '@trivie/core'
import { Avatar, color, Text } from '@trivie/ui-mobile'
import { SettingsList } from '../../settings/settings-screen/settings-list'
import { useMediaQuery } from '@mui/material'
export const AltProfileScreen = observer(() => {
  const { userStore } = useStores()
  const { user, getUser } = userStore

  const isMobile = !useMediaQuery('(min-width:800px)')

  useEffect(() => {
    if (user) {
      getUser(user.id)
    }
  }, [])

  const FULL: ViewStyle = { paddingTop: isMobile ? 10 : 0, paddingHorizontal: isMobile ? 10 : 0 }

  return (
    <View style={FULL}>
      <View style={CONTAINER}>
        <View style={USER_CONTAINER}>
          <Avatar
            source={user?.photo_url}
            name={`${user?.first_name} ${user?.last_name}`}
            size="large"
          />
          <Text
            style={NAME}
            text={`${user?.first_name} ${user?.last_name}`}
            variant="titleEmphasized"
          />
          <Text text={user?.email} variant="body2" style={EMAIL} />
        </View>
        <SettingsList />
      </View>
    </View>
  )
})

/**
 * Styling
 */

const CONTAINER: ViewStyle = { backgroundColor: color.white }
const USER_CONTAINER: ViewStyle = {
  alignItems: 'center',
  flexDirection: 'column',
  alignSelf: 'center',
  justifyContent: 'center',
}
const NAME: TextStyle = { marginBottom: 4, lineHeight: 20, alignSelf: 'center' }
const EMAIL: TextStyle = { lineHeight: 14.52, alignSelf: 'center', color: 'rgba(144, 152, 163, 1)' }
